export default __webpack_public_path__ + "static/media/ic-chevron-down.dc1f6709.svg";